import { AppDispatch } from "app/store";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import {
  COUNTRY_LIST,
  JOB_TYPE_LIST,
  PREFECTURE_LIST,
  changeEmail,
  changeEmailCheck,
  changePassword,
  changePasswordCheck,
  changeCountry,
  changeFamilyName,
  changeFirstName,
  changeFamilyNameFurigana,
  changeFirstNameFurigana,
  changeCompany,
  changeCompanyFurigana,
  changeOffice,
  changeDepartment,
  changePosition,
  changeJobType,
  changeCompanyTel,
  changePostalCode,
  changeState,
  changeCity,
  changeAddress,
  changeBuildingName,
  cleanupByCountyChange,
  changePageState,
  changeMarket_Status,
  selectEmail,
  selectEmailCheck,
  selectPassword,
  selectPasswordCheck,
  selectCountry,
  selectFamilyName,
  selectFirstName,
  selectFamilyNameFurigana,
  selectFirstNameFurigana,
  selectCompany,
  selectCompanyFurigana,
  selectOffice,
  selectDdepartment,
  selectPosition,
  selectJobType,
  selectCompanyTel,
  selectPostalCode,
  selectState,
  selectCity,
  selectAddress,
  selectBuildingName,
  selectPostalError,
  selectInputValidationErrors,
  selectMarket_Status,
} from "features/signup";
import { postalCodeAsync } from "features/signup/operations";
import { useTranslation } from "react-i18next";
import { inputtingPattern } from "common/validateTelephoneNumber";
import { focusingScroll } from "common/focusingScroll";
import {
  EMAIL_MAX_LENGTH,
  NAME_MAX_LENGTH,
  PASSWORD_MAX_LENGTH,
  POSTAL_CODE_MAX_LENGTH,
  PROFILE_COLUMN_LENGTH,
  TEL_MAX_LENGTH,
} from "../../common/constants";

interface Param {
  scrollOffset: number;
}
export const SignupFormJapan: React.FC<Param> = ({
  scrollOffset,
}: Param): JSX.Element => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const [isFocusing, setForcusing] = useState(false);

  const emailRef = useRef<HTMLElement>(null);
  const passwordRef = useRef<HTMLElement>(null);
  const countryRef = useRef<HTMLElement>(null);
  const fullNameRef = useRef<HTMLElement>(null);
  const fullNameFuriganaRef = useRef<HTMLElement>(null);
  const companyRef = useRef<HTMLElement>(null);
  const companyFuriganaRef = useRef<HTMLElement>(null);
  const companyTelRef = useRef<HTMLElement>(null);
  const postalCodeRef = useRef<HTMLElement>(null);
  const prefectureRef = useRef<HTMLElement>(null);
  const cityRef = useRef<HTMLElement>(null);

  const errors = useSelector(selectInputValidationErrors);

  const [error, SetError] = useState({
    hasErrorEmptyEmail: false,
    hasErrorEmptyPassword: false,
    hasErrorEmptyCountry: false,
    hasErrorEmptyName: false,
    hasErrorEmptyCompany: false,
    hasErrorEmptyPostalCode: false,
    hasErrorEmptyState: false,
    hasErrorEmptyCity: false,
    hasErrorIncorrectEmail: false,
    hasErrorNotMatchEmail: false,
    hasErrorIncorrectPassword: false,
    hasErrorNotMatchPassword: false,
    hasErrorIncorrectNameFurigana: false,
    hasErrorIncorrectCompanyFurigana: false,
    hasErrorIncorrectPostalCode: false,
    hasErrorIncorrectTelephoneNumber: false,
  });

  const onSubmit = useCallback(() => {
    SetError(errors);
    if (
      errors.hasErrorEmptyEmail ||
      errors.hasErrorEmptyPassword ||
      errors.hasErrorEmptyCountry ||
      errors.hasErrorEmptyName ||
      errors.hasErrorEmptyCompany ||
      errors.hasErrorEmptyPostalCode ||
      errors.hasErrorEmptyState ||
      errors.hasErrorEmptyCity ||
      errors.hasErrorIncorrectEmail ||
      errors.hasErrorNotMatchEmail ||
      errors.hasErrorIncorrectPassword ||
      errors.hasErrorNotMatchPassword ||
      errors.hasErrorIncorrectNameFurigana ||
      errors.hasErrorIncorrectCompanyFurigana ||
      errors.hasErrorIncorrectPostalCode ||
      errors.hasErrorIncorrectTelephoneNumber
    ) {
      setForcusing(true);
      return;
    }
    dispatch(changePageState({ pageState: "confirm" }));
  }, [errors, dispatch]);

  useEffect(() => {
    if (!isFocusing) {
      return;
    }

    let element: HTMLElement | null;
    if (
      errors.hasErrorEmptyEmail ||
      errors.hasErrorIncorrectEmail ||
      errors.hasErrorNotMatchEmail
    ) {
      element = emailRef.current;
    } else if (
      errors.hasErrorEmptyPassword ||
      errors.hasErrorIncorrectPassword ||
      errors.hasErrorNotMatchPassword
    ) {
      element = passwordRef.current;
    } else if (errors.hasErrorEmptyCountry) {
      element = countryRef.current;
    } else if (errors.hasErrorEmptyName) {
      element = fullNameRef.current;
    } else if (errors.hasErrorIncorrectNameFurigana) {
      element = fullNameFuriganaRef.current;
    } else if (errors.hasErrorEmptyCompany) {
      element = companyRef.current;
    } else if (errors.hasErrorIncorrectCompanyFurigana) {
      element = companyFuriganaRef.current;
    } else if (errors.hasErrorIncorrectTelephoneNumber) {
      element = companyTelRef.current;
    } else if (
      errors.hasErrorEmptyPostalCode ||
      errors.hasErrorIncorrectPostalCode
    ) {
      element = postalCodeRef.current;
    } else if (errors.hasErrorEmptyState) {
      element = prefectureRef.current;
    } else if (errors.hasErrorEmptyCity) {
      element = cityRef.current;
    } else {
      element = null;
    }
    if (element != null) {
      focusingScroll(element, scrollOffset);
    }
    setForcusing(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocusing]);

  const email = useSelector(selectEmail);
  const emailCheck = useSelector(selectEmailCheck);
  const password = useSelector(selectPassword);
  const passwordCheck = useSelector(selectPasswordCheck);
  const country = useSelector(selectCountry);
  const familyName = useSelector(selectFamilyName);
  const firstName = useSelector(selectFirstName);
  const familyNameFurigana = useSelector(selectFamilyNameFurigana);
  const firstNameFurigana = useSelector(selectFirstNameFurigana);
  const company = useSelector(selectCompany);
  const companyFurigana = useSelector(selectCompanyFurigana);
  const office = useSelector(selectOffice);
  const department = useSelector(selectDdepartment);
  const position = useSelector(selectPosition);
  const jobType = useSelector(selectJobType);
  const companyTel = useSelector(selectCompanyTel);
  const postalCode = useSelector(selectPostalCode);
  const state = useSelector(selectState);
  const city = useSelector(selectCity);
  const address = useSelector(selectAddress);
  const buildingName = useSelector(selectBuildingName);
  const postalError = useSelector(selectPostalError);
  const market_status = useSelector(selectMarket_Status);

  const [isAgreePolicy, setIsAgreePolicy] = useState(false);

  return (
    <Section>
      <FormList>
        <FormDt ref={emailRef}>
          {t("signupPage.label.email")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          <FormInput
            name="email"
            value={email}
            isError={error.hasErrorEmptyEmail || error.hasErrorIncorrectEmail}
            type="email"
            size={60}
            maxLength={EMAIL_MAX_LENGTH}
            onChange={(event) =>
              dispatch(changeEmail({ email: event.target.value }))
            }
          />
          <FormComment>{t("signupPage.text.emailComment")}</FormComment>
          {error.hasErrorEmptyEmail && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
          {error.hasErrorIncorrectEmail && (
            <ErrorComment>
              {t("signupPage.message.invalidEmailFormatError")}
            </ErrorComment>
          )}
          <FormInput
            name="email_confirm"
            value={emailCheck}
            isError={error.hasErrorNotMatchEmail}
            type="email"
            size={60}
            maxLength={EMAIL_MAX_LENGTH}
            placeholder={t("signupPage.label.inputConfirm")}
            marginTop="1rem"
            onChange={(event) =>
              dispatch(changeEmailCheck({ emailCheck: event.target.value }))
            }
          />
          {error.hasErrorNotMatchEmail && (
            <ErrorComment>
              {t("signupPage.message.notMatchEmailError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={passwordRef}>
          {t("signupPage.label.password")}
          <Required>{t("signupPage.label.required")}</Required>
          <FormComment>
            {t("signupPage.label.passwordAllowdCharactoers")}
            <br />
            {t("signupPage.label.passwordContainsLowerCase")}
            <br />
            {t("signupPage.label.passwordContainsUpperCase")}
            <br />
            {t("signupPage.label.passwordContainsNumberAndSymbol")}
          </FormComment>
        </FormDt>
        <FormDd>
          <FormInput
            name="password"
            value={password}
            isError={
              error.hasErrorEmptyPassword || error.hasErrorIncorrectPassword
            }
            type="password"
            size={40}
            maxLength={PASSWORD_MAX_LENGTH}
            onChange={(event) =>
              dispatch(changePassword({ password: event.target.value }))
            }
          />
          {error.hasErrorEmptyPassword && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
          {error.hasErrorIncorrectPassword && (
            <ErrorComment>
              {t("signupPage.message.notAllowedPasswordRuleError")}
            </ErrorComment>
          )}
          <br />
          <FormInput
            name="password_confirm"
            value={passwordCheck}
            isError={error.hasErrorNotMatchPassword}
            type="password"
            size={40}
            maxLength={PASSWORD_MAX_LENGTH}
            placeholder={t("signupPage.label.inputConfirm")}
            marginTop="1rem"
            onChange={(event) =>
              dispatch(
                changePasswordCheck({ passwordCheck: event.target.value })
              )
            }
          />
          {error.hasErrorNotMatchPassword && (
            <ErrorComment>
              {t("signupPage.message.notMatchPasswordError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={countryRef}>
          {t("signupPage.label.country")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          <FormSelect
            value={country}
            isError={error.hasErrorEmptyCountry}
            onChange={(event) => {
              if (event.target.value !== "" && event.target.value !== country) {
                dispatch(cleanupByCountyChange());
              }
              dispatch(changeCountry({ country: event.target.value }));
            }}
          >
            <Option value="">{t("signupPage.label.pullDownSelect")}</Option>
            {COUNTRY_LIST.map((x) => (
              <Option key={x.value} disabled={x.disabled} value={x.value}>
                {x.disabled || <>&nbsp;&nbsp;</>}
                {x.label}
              </Option>
            ))}
          </FormSelect>
          {error.hasErrorEmptyCountry && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={fullNameRef}>
          {t("signupPage.label.fullName")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          {t("signupPage.label.familyName")}&emsp;：
          <FormInput
            value={familyName}
            isError={error.hasErrorEmptyName}
            type="text"
            size={15}
            maxLength={NAME_MAX_LENGTH}
            onChange={(event) =>
              dispatch(changeFamilyName({ familyName: event.target.value }))
            }
            placeholder={t("signupPage.label.familyName_pl")}
          />
          &emsp;{t("signupPage.label.givenName")}&emsp;：
          <FormInput
            value={firstName}
            isError={error.hasErrorEmptyName}
            type="text"
            size={15}
            maxLength={NAME_MAX_LENGTH}
            onChange={(event) =>
              dispatch(changeFirstName({ firstName: event.target.value }))
            }
            placeholder={t("signupPage.label.givenName_pl")}
          />
          {error.hasErrorEmptyName && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={fullNameFuriganaRef}>
          {t("signupPage.label.fullNameFurigana")}
          <FormComment>{t("signupPage.label.nameFuriganaFormat")}</FormComment>
        </FormDt>
        <FormDd>
          {t("signupPage.label.familyNameFurigana")}：
          <FormInput
            value={familyNameFurigana}
            isError={error.hasErrorIncorrectNameFurigana}
            type="text"
            size={15}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(
                changeFamilyNameFurigana({
                  familyNameFurigana: event.target.value,
                })
              )
            }
            placeholder={t("signupPage.label.familyNameFurigana_pl")}
          />
          &emsp;
          {t("signupPage.label.givenNameFurigana")}：
          <FormInput
            value={firstNameFurigana}
            isError={error.hasErrorIncorrectNameFurigana}
            type="text"
            size={15}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(
                changeFirstNameFurigana({
                  firstNameFurigana: event.target.value,
                })
              )
            }
            placeholder={t("signupPage.label.givenNameFurigana_pl")}
          />
          {error.hasErrorIncorrectNameFurigana && (
            <ErrorComment>
              {t("signupPage.message.invalidFuriganaFormatError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={companyRef}>
          {t("signupPage.label.company")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          <FormInput
            value={company}
            isError={error.hasErrorEmptyCompany}
            type="text"
            size={40}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeCompany({ company: event.target.value }))
            }
            placeholder={t("signupPage.label.company_pl")}
          />
          <FormComment>{t("signupPage.text.companyComment")}</FormComment>
          {error.hasErrorEmptyCompany && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={companyFuriganaRef}>
          {t("signupPage.label.companyFurigana")}
          <FormComment>{t("signupPage.label.nameFuriganaFormat")}</FormComment>
        </FormDt>
        <FormDd>
          <FormInput
            value={companyFurigana}
            isError={error.hasErrorIncorrectCompanyFurigana}
            type="text"
            size={40}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(
                changeCompanyFurigana({ companyFurigana: event.target.value })
              )
            }
            placeholder={t("signupPage.label.companyFurigana_pl")}
          />
          <FormComment>
            {t("signupPage.text.companyFuriganaComment")}
          </FormComment>
          {error.hasErrorIncorrectCompanyFurigana && (
            <ErrorComment>
              {t("signupPage.message.invalidFuriganaFormatError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt>{t("signupPage.label.office")}</FormDt>
        <FormDd>
          <FormInput
            value={office}
            type="text"
            size={40}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeOffice({ office: event.target.value }))
            }
            placeholder={t("signupPage.label.office_pl")}
          />
        </FormDd>
        <FormDt>{t("signupPage.label.department")}</FormDt>
        <FormDd>
          <FormInput
            value={department}
            type="text"
            size={40}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeDepartment({ department: event.target.value }))
            }
            placeholder={t("signupPage.label.department_pl")}
          />
          <FormComment>{t("signupPage.text.departmentComment")}</FormComment>
        </FormDd>
        <FormDt>{t("signupPage.label.position")}</FormDt>
        <FormDd>
          <FormInput
            value={position}
            type="text"
            size={40}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changePosition({ position: event.target.value }))
            }
            placeholder={t("signupPage.label.position_pl")}
          />
        </FormDd>
        <FormDt>{t("signupPage.label.jobType")}</FormDt>
        <FormDd>
          <FormSelect
            value={jobType}
            onChange={(event) =>
              dispatch(changeJobType({ jobType: event.target.value }))
            }
          >
            <Option value="">{t("signupPage.label.pullDownSelect")}</Option>
            {JOB_TYPE_LIST.map((x) => (
              <Option key={x.value} value={x.value}>
                {t(x.label)}
              </Option>
            ))}
          </FormSelect>
        </FormDd>
        <FormDt ref={companyTelRef}>
          {t("signupPage.label.companyTel")}
          <FormComment>{t("signupPage.label.companyTelFormat")}</FormComment>
        </FormDt>
        <FormDd>
          <FormInput
            value={companyTel}
            isError={error.hasErrorIncorrectTelephoneNumber}
            type="tel"
            size={40}
            maxLength={TEL_MAX_LENGTH}
            marginRignt="0.9rem"
            onChange={(event) => {
              if (event.target.value.match(inputtingPattern)?.length !== 1) {
                event.target.value = companyTel;
              }
              dispatch(changeCompanyTel({ companyTel: event.target.value }));
            }}
          />
          {error.hasErrorIncorrectTelephoneNumber && (
            <ErrorComment>
              {t("signupPage.message.invalidTelephoneNumberFormatError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={postalCodeRef}>
          {t("signupPage.label.postalCode")}
          <Required>{t("signupPage.label.required")}</Required>
          <FormComment>{t("signupPage.label.postalCodeFormat")}</FormComment>
        </FormDt>
        <FormDd>
          <FormInput
            value={postalCode}
            isError={
              error.hasErrorEmptyPostalCode || error.hasErrorIncorrectPostalCode
            }
            type="text"
            size={20}
            maxLength={POSTAL_CODE_MAX_LENGTH}
            onChange={(event) =>
              dispatch(changePostalCode({ postalCode: event.target.value }))
            }
          />
          &emsp;
          <FormButton
            type="button"
            value={t("signupPage.label.postalCodeButton")}
            onClick={() => dispatch(postalCodeAsync({ postalCode }))}
          />
          {error.hasErrorEmptyPostalCode && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
          {postalError !== "BadRequest" &&
            error.hasErrorIncorrectPostalCode && (
              <ErrorComment>
                {t("signupPage.message.invalidPostalCodeFormatError")}
              </ErrorComment>
            )}
          {postalError === "BadRequest" && (
            <ErrorComment>
              {t("signupPage.message.invalidPostalCodeFormatError")}
            </ErrorComment>
          )}
          {postalError === "Error" && (
            <ErrorComment>
              {t("signupPage.message.faildGetPostalCodeError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={prefectureRef}>
          {t("signupPage.label.prefectures")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          <FormSelect
            value={state}
            isError={error.hasErrorEmptyState}
            onChange={(event) =>
              dispatch(changeState({ state: event.target.value }))
            }
          >
            <Option value="">{t("signupPage.label.pullDownSelect")}</Option>
            {PREFECTURE_LIST.map((x) => (
              <Option key={x.value} value={x.value}>
                {x.label}
              </Option>
            ))}
          </FormSelect>
          {error.hasErrorEmptyState && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt ref={cityRef}>
          {t("signupPage.label.city")}
          <Required>{t("signupPage.label.required")}</Required>
        </FormDt>
        <FormDd>
          <FormInput
            value={city}
            isError={error.hasErrorEmptyCity}
            type="text"
            size={60}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeCity({ city: event.target.value }))
            }
          />
          {error.hasErrorEmptyCity && (
            <ErrorComment>
              {t("signupPage.message.requiredEmptyError")}
            </ErrorComment>
          )}
        </FormDd>
        <FormDt>{t("signupPage.label.address")}</FormDt>
        <FormDd>
          <FormInput
            value={address}
            type="text"
            size={60}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeAddress({ address: event.target.value }))
            }
          />
        </FormDd>
        <FormDt marginBottom="2rem">{t("signupPage.label.building")}</FormDt>
        <FormDd marginBottom="2rem">
          <FormInput
            value={buildingName}
            type="text"
            size={60}
            maxLength={PROFILE_COLUMN_LENGTH}
            onChange={(event) =>
              dispatch(changeBuildingName({ buildingName: event.target.value }))
            }
          />
        </FormDd>
        <SubmitArea>
          <Text>{t("signupPage.text.privacyPolicy")} </Text>
          <PolicyUl>
            <PolicyLi>
              <PolicyLink
                href="https://www.fa.omron.co.jp/footer/privacy.html"
                target="_blank"
              >
                {t("signupPage.label.japan")}
              </PolicyLink>
            </PolicyLi>
            <PolicyLi>
              <PolicyLink
                href="http://www.ia.omron.co.kr/member/police3.asp"
                target="_blank"
              >
                {t("signupPage.label.korea")}
              </PolicyLink>
            </PolicyLi>
            <PolicyLi>
              <PolicyLink
                href="https://www.fa.omron.com.cn/syxz"
                target="_blank"
              >
                {t("signupPage.label.china")}
              </PolicyLink>
            </PolicyLi>
            <PolicyLi>
              <PolicyLink
                href="https://www.omron-ap.com/privacy_policy.asp"
                target="_blank"
              >
                {t("signupPage.label.asiaPacific")}
              </PolicyLink>
            </PolicyLi>
            <PolicyLi>
              <PolicyLink
                href="https://industrial.omron.eu/en/misc/privacy-policy"
                target="_blank"
              >
                {t("signupPage.label.europeMiddleEastAfrica")}
              </PolicyLink>
            </PolicyLi>
            <PolicyLi>
              <PolicyLink
                href="https://automation.omron.com/en/us/privacy-policy"
                target="_blank"
              >
                {t("signupPage.label.unitedStates")}
              </PolicyLink>
            </PolicyLi>
          </PolicyUl>
          <PolicyAgreeArea>
            <PolicyAgreeDiv>
              <PolicyCheckBox
                id="policy-agree"
                type="checkbox"
                name="agree"
                onChange={(e) => {
                  setIsAgreePolicy(e.target.checked);
                }}
              />
              <PolicyCheckBoxLabel>
                {t("signupPage.label.agreePolicy")}
              </PolicyCheckBoxLabel>
            </PolicyAgreeDiv>
            <PolicyAgreeDiv>
              <PolicyCheckBox
                id="market-agree"
                type="checkbox"
                name="market_agree"
                checked={market_status}
                onChange={(e) =>
                  dispatch(
                    changeMarket_Status({ market_status: e.target.checked })
                  )
                }
              />
              <MarketCheckBoxLabel>
                {t("signupPage.label.agreeMarketPolicy")}
              </MarketCheckBoxLabel>
            </PolicyAgreeDiv>
          </PolicyAgreeArea>
          <SubmitButton
            type="button"
            value={t("signupPage.label.submitButton")}
            onClick={onSubmit}
            disabled={!isAgreePolicy}
          />
          <HelpDesk>{t("signupPage.label.helpDesk")} </HelpDesk>
        </SubmitArea>
      </FormList>
    </Section>
  );
};

export default SignupFormJapan;

const Section = styled.section``;

const FormList = styled.dl`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 3rem;
`;

const FormDt = styled.dt<{ marginBottom?: string }>`
  margin-bottom: ${(props) => props.marginBottom || "0"};
  width: 26%;
  padding: 1.3rem 2%;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  background: #fafafa;
  :nth-of-type(2n) {
    background: #f0f0f0;
  }
`;
const FormDd = styled.dd<{ marginBottom?: string }>`
  margin-bottom: ${(props) => props.marginBottom || "0"};
  width: 70%;
  padding: 1rem 0;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  background: #fafafa;
  :nth-of-type(2n) {
    background: #f0f0f0;
  }
`;

const Required = styled.p`
  display: inline-block;
  color: #e50000;
  float: right;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0;
  font-weight: normal;
`;

const FormInput = styled.input<{
  marginRignt?: string;
  marginTop?: string;
  isError?: boolean;
}>`
  margin-right: ${(props) => props.marginRignt || "0"};
  margin-top: ${(props) => props.marginTop || "0"};
  padding: 0.5rem 0.8rem;
  border: 1px #999999 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  :focus {
    outline: 0;
    background: #fafafa;
  }

  ${({ isError }) =>
    isError &&
    css`
      background: rgba(229, 0, 0, 0.08);
      :focus {
        background: rgba(229, 0, 0, 0.08);
      }
    `}
`;

const FormButton = styled(FormInput)`
  padding: 0.5rem 0.8rem;
  border: 1px #999999 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  background: #f0f0f0;
  cursor: pointer;
  :hover {
    background: #e6e6e6;
  }
`;

const FormSelect = styled.select<{ isError?: boolean }>`
  padding: 0.5rem 0.8rem;
  border: 1px #999999 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  :focus {
    outline: 0;
    background: #fafafa;
  }
  ${({ isError }) =>
    isError &&
    css`
      background: rgba(229, 0, 0, 0.08);
      :focus {
        background: rgba(229, 0, 0, 0.08);
      }
    `}
`;

const FormComment = styled.span<{ marginTop?: string }>`
  margin-top: ${(props) => props.marginTop || "0"};
  display: block;
  color: #999999;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0;
  font-weight: normal;
`;

const TelSpan = styled.span`
  margin-right: 0.9rem;
`;

const SubmitArea = styled.dd`
  width: 100%;
  background: none;
  text-align: center;
`;

const SubmitButton = styled.input<{ disabled?: boolean }>`
  width: 15rem;
  padding: 1.23rem 2rem;
  border: 1px #005eb8 solid;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  opacity: 1;
  pointer-events: none;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  cursor: pointer;
  color: #ffffff;
  background: #005eb8;
  pointer-events: auto;
  :hover {
    background: rgba(0, 94, 184, 0.7);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: #999999;
      background: #f5f5f5;
      border: 1px #e6e6e6 solid;
      pointer-events: none;
      :hover {
        background: #fafafa;
      }
    `}
`;

const ErrorComment = styled.span`
  margin-top: 0.2rem;
  display: block;
  color: #e50000;
  font-size: 11px;
  line-height: 1.6;
  letter-spacing: 0;
  font-weight: normal;
`;

const Option = styled.option`
  :disabled {
    background: #e6e6e6;
  }
`;

// TODO:ポリシー
const Text = styled.p`
  margin-bottom: 1rem;
  font-size: 14px;
  line-height: 1.7;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
  text-align: left;
`;

const PolicyUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
const PolicyLi = styled.li`
  margin-right: 2rem;
  margin-bottom: 1rem;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0;
  font-weight: normal;
  :last-child {
    margin-right: 0;
  }
`;
const PolicyLink = styled.a`
  color: #005eb8;
  border: 1px #005eb8 solid;
  border-radius: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-right: 5px;
  padding-left: 5px;
  text-decoration: none;
`;

const PolicyAgreeArea = styled.div`
  position: relative;
  margin-top: 3rem;
  margin-bottom: 3rem;
  justify-content: center;
  text-align: left;
`;

const PolicyAgreeDiv = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 16px;
`;

const PolicyCheckBox = styled.input`
  display: block;
  padding: 0;
  margin: 0;
  appearance: none;
  background-color: initial;
  cursor: default;

  + label:before {
    content: "";
    left: 0;
    top: 0;
    width: 24px;
    height: 24px;
    border: #999999 solid 1px;
    background-color: #ffffff;
    position: absolute;
    display: block;
    box-sizing: border-box;
  }
  :focus + label:before {
    box-shadow: 0 0 4px #005eb8;
  }
  :checked + label:before {
    border: #005eb8 solid 1px;
    background-color: #005eb8;
  }

  + label:after {
    content: "";
    position: absolute;
    display: block;
    box-sizing: border-box;
    left: 4px;
    top: 6px;
    transform: rotate(-45deg);
    width: 16px;
    height: 8px;
    border-left: #ffffff solid 3px;
    border-bottom: #ffffff solid 3px;
  }
  :focus + label:after {
  }
  :checked + label:after {
    display: block;
  }
`;

const PolicyCheckBoxLabel = styled.label.attrs({
  'for': 'policy-agree'
})`
  display: block;
  padding-left: 35px;
  max-height: calc(3.5em * 1.7);
  overflow-x: auto;
`;

const MarketCheckBoxLabel = styled.label.attrs({
  'for': 'market-agree'
})`
  display: block;
  padding-left: 35px;
  max-height: calc(3.5em * 1.7);
  overflow-x: auto;
`;

const HelpDesk = styled.p`
  margin-top: 3rem;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: normal;
  white-space: pre-wrap;
  text-align: center;
`;
